import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1df0cb3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]

import { IBasicForm, TFormField, TFormFieldComponent } from './../../const/types/form'
import { IonNote, IonItem, IonLabel, IonCheckbox, loadingController } from '@ionic/vue';
import { reactive, computed, onMounted, watch, onUnmounted } from 'vue'
import type { Component } from 'vue';
import { useVuelidate } from '@vuelidate/core'
import BasicSliderButton from './BasicSliderButton.vue'
import BasicNormalInput from './form-elements/BasicNormalInput.vue';
import BasicNormalSelect from './form-elements/BasicNormalSelect.vue';

interface Props {
  schema: IBasicForm;
  isLoading?: boolean;
  submitType?: 'none' | 'button'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicForm',
  props: {
    schema: null,
    isLoading: { type: Boolean },
    submitType: null
  },
  setup(__props: any) {

const props = __props as {
  schema: IBasicForm;
  isLoading?: boolean;
  submitType?: 'none' | 'button'
};



onMounted(() => {
    props.schema.inputs.forEach((input) => {
        inputsValues[input.name] = input.fieldValue ? input.fieldValue : undefined
    })
})

const inputsValues = reactive({})
const inputsRules = computed(() => {
    const rules = {}
    props.schema.inputs.forEach(input => rules[input.name] = input.validation ?? {})

    return rules
})

const v$ = useVuelidate(inputsRules, inputsValues)
const inputsErrors = computed(() => (v$.value.$errors))

const getInputErrorMessages = (inputName: string) => {
    const inputErrors = inputsErrors.value.filter(error => error.$property === inputName)

    const errorMessages = inputErrors.map(error => error.$message)

    const errorMessage = errorMessages.toLocaleString()

    return errorMessage
}

const onSuccess = () => {
    if (props.schema.handlers?.onSuccess) {
        props.schema.handlers.onSuccess(inputsValues)
    }
}

const onError = () => {
    if (props.schema.handlers?.onError) {
        props.schema.handlers.onError()
    }
}

const handleSubmitForm = () => {
    v$.value.$validate()

    if (inputsErrors.value.length > 0) {
        return
    }

    if (props.schema.customValidator) {
        const validated = props.schema.customValidator(inputsValues)
        
        if (!validated) {
            onError()
            return
        }
    }

    onSuccess()
}

const COMPONENTS_LIST: {
    [key in TFormFieldComponent]: Component;
} = {
    'basic': BasicNormalInput,
    'basicSelect': BasicNormalSelect,
    'checkbox': IonCheckbox,
}

const getComponentName = (input: TFormField) => {
    if (input.component) {
        return COMPONENTS_LIST[input.component]
    }

    return COMPONENTS_LIST[input.type]
}

let spinnerNode: HTMLIonLoadingElement | null = null;

watch(props, async () => {
    if (!spinnerNode) {
        spinnerNode = await loadingController.create({
            message: 'Loading...',
            spinner: 'dots',
            mode: 'ios',
        });
    }

    if (props.isLoading) {
        spinnerNode!.present();
    } else {
        spinnerNode!.dismiss()

        // Once is dismissed can't be fired again so I created new, ugly -> but imo the best way
        spinnerNode = await loadingController.create({
            message: 'Loading...',
            spinner: 'dots',
            mode: 'ios',
        });
    }
}, { deep: true, })

onUnmounted(() => {
    if (spinnerNode) spinnerNode.dismiss()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.schema.inputs, (input) => {
      return (_openBlock(), _createBlock(_unref(IonItem), {
        key: input.name,
        class: _normalizeClass(["ion-no-padding ion-margin-bottom", {'ion-invalid': getInputErrorMessages(input.name)}])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLabel), { position: "stacked" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(input.label) + ":", 1)
            ]),
            _: 2
          }, 1024),
          (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentName(input)), _mergeProps({
            name: input.name
          }, input.props, {
            modelValue: inputsValues[input.name],
            "onUpdate:modelValue": ($event: any) => ((inputsValues[input.name]) = $event)
          }), null, 16, ["name", "modelValue", "onUpdate:modelValue"])),
          _createVNode(_unref(IonNote), { class: "input__error" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getInputErrorMessages(input.name)), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["class"]))
    }), 128)),
    (props.submitType != 'none')
      ? (_openBlock(), _createBlock(BasicSliderButton, {
          key: 0,
          disabled: _unref(inputsErrors).length > 0,
          onOnSuccess: handleSubmitForm
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}
}

})